import UserConsole from './UserConsole.vue'

export default UserConsole


// WEBPACK FOOTER //
// ./src/pages/UserConsole/index.js